import { render, staticRenderFns } from "./TicketMixSub.vue?vue&type=template&id=47b50df1&scoped=true&"
import script from "./TicketMixSub.vue?vue&type=script&lang=js&"
export * from "./TicketMixSub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b50df1",
  null
  
)

export default component.exports